module.exports = __webpack_public_path__ + "media/styles/images/svg/table-handle-71dd91471684810c69df506a50848fd6.svg";